import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const clipboardPluginKey = new PluginKey('clipboardPlugin');
